import {getFromStore, StorePath} from '../services/store.service';

export function useIsDebugMode(): boolean {
	return getFromStore(StorePath.IS_DEBUG_MODE) as boolean;
}
